export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14117.a5b2f864.jpg";